import { restApi } from "@/api";

export const fetchCountryData = () => {
  return restApi.get("/dataCountry");
};

